module.exports = __webpack_public_path__ + "static/img/dentaire-02.a3ac42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentaire-02.png
// module id = 82
// module chunks = 0